const BackArrow = ({ className = '' }) => (
  <svg
    className={className}
    width='22'
    height='18'
    viewBox='0 0 22 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M22 9H2' stroke='' strokeWidth='2' strokeMiterlimit='10' />
    <path
      d='M9 16L2 9L9 2'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default BackArrow
